// import React, { useEffect, useState } from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import apiClient from "../../api/axiosClient";


// const TEMPLATE_FILENAME = "Goal Net Zero Company of the Year Award_2025.xlsx";

// const rowMapping = {
//   organisationname: 5,
//   Net_Zero_Target:10,
//   Carbon_Emitted_2024: 15,
//   Carbon_Emitted_2023: 16,
//   Total_Energy_Consumed_2024:26,
//   Total_Energy_Consumed_2023:27,
//   Annual_Revenue_2024:29,
//   Annual_Revenue_2023:30,
//   Capex_Wind_2024:34, 
//   Capex_Solar_2024:35, 
//   Capex_Other_2024:36, 
//   Total_Renewable_2024:38,
//   Total_Renewable_2023:39,
//   Total_Power_2024:44,
//   Investment_GH2_2024:47,
//   GH2_Production_2024:49,
//   Tree_Plantation_2024:51,
//   Capex_CCS_2024:54,
//   Carbon_Captured_2024:56,
  
// };

// /** Helpers for Excel columns / range */
// const colLetter = (colIndex) => {
//   let letters = "";
//   while (colIndex >= 0) {
//     letters = String.fromCharCode((colIndex % 26) + 65) + letters;
//     colIndex = Math.floor(colIndex / 26) - 1;
//   }
//   return letters;
// };

// const colIndexFromLetter = (col) => {
//   let index = 0;
//   for (let i = 0; i < col.length; i++) {
//     index = index * 26 + (col.charCodeAt(i) - 65 + 1);
//   }
//   return index - 1;
// };

// const expandSheetRange = (sheet, minCol, minRow, maxCol, maxRow) => {
//   const start = `${colLetter(minCol)}${minRow}`;
//   const end = `${colLetter(maxCol)}${maxRow}`;
//   sheet["!ref"] = `${start}:${end}`;
// };

// const ExcelGNZ = () => {
//   const [apiData, setApiData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [exported, setExported] = useState(false); // ensure single run

  
//   useEffect(() => {
//     (async () => {
//       try {
//         const resp = await apiClient.get("/vw-goalnetzero-submitted/");
//         const results = (resp.data && (resp.data.results ?? resp.data)) || [];
//         console.log("API results length:", results.length, "first:", results[0]);
//         setApiData(results);
//       } catch (err) {
//         console.error("API fetch error:", err);
//         setError("Failed to fetch API data. See console.");
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   useEffect(() => {
//     if (!loading && !error && apiData && apiData.length > 0 && !exported) {
//       (async () => {
//         try {
//           await performExport(apiData);
//           setExported(true);
//         } catch (err) {
//           console.error("Auto-export failed:", err);
       
//         }
//       })();
//     }
//   }, [loading, error, apiData, exported]);

//   // main export logic extracted so we can call it from useEffect
//   const performExport = async (dataToWrite) => {
//     if (!dataToWrite || dataToWrite.length === 0) {
//       throw new Error("No API data to export.");
//     }

//     const url = encodeURI(`${process.env.PUBLIC_URL || ""}/templates/${TEMPLATE_FILENAME}`);
//     console.log("Fetching template:", url);
//     const resp = await fetch(url);
//     if (!resp.ok) throw new Error(`Template not found (status ${resp.status})`);

//     const contentType = resp.headers.get("content-type") || "";
//     if (contentType.includes("text/html")) {
//       const txt = await resp.text();
//       console.error("Template fetch returned HTML (first 300 chars):", txt.slice(0, 300));
//       throw new Error("Template returned HTML. Check file path/name.");
//     }

//     const arrayBuffer = await resp.arrayBuffer();
//     const magic = new Uint8Array(arrayBuffer.slice(0, 4));
//     console.log("Template magic bytes:", magic, "->", String.fromCharCode(...magic));
//     if (!String.fromCharCode(...magic).startsWith("PK")) {
//       console.warn("Template does not look like xlsx (missing PK).");
//     }

//     const workbook = XLSX.read(arrayBuffer, { type: "array" });
//     if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
//       throw new Error("Workbook contains no sheets.");
//     }
//     const sheetName = workbook.SheetNames[0];
//     const sheet = workbook.Sheets[sheetName];
//     console.log("Using sheet:", sheetName, "initial !ref:", sheet["!ref"]);

//     // compute existing bounds
//     const existingRef = sheet["!ref"] || "A1:A1";
//     const [startRef, endRef] = existingRef.split(":");
//     const startColLetter = (startRef || "A1").replace(/[0-9]/g, "");
//     const startRow = parseInt((startRef || "A1").replace(/[A-Z]/gi, ""), 10) || 1;
//     const endColLetter = (endRef || startRef || "A1").replace(/[0-9]/g, "");
//     const endRow = parseInt((endRef || startRef || "A1").replace(/[A-Z]/gi, ""), 10) || 1;

//     let minCol = colIndexFromLetter(startColLetter || "A");
//     let minRow = startRow;
//     let maxCol = colIndexFromLetter(endColLetter || "A");
//     let maxRow = endRow;

//     // For each company (row of data), map fields to variables and write into column (G, H, I...)
//     dataToWrite.forEach((company, idx) => {
//       const colIndex = 9 + idx; // G = 6
//       const col = colLetter(colIndex);
//       console.log(`\n--- Writing company #${idx + 1} into column ${col} ---`);

//       // MANUAL variable mapping (explicit)
//       const organisationname = company.organisation_name;
//       const Net_Zero_Target = company.net_zero_target_2024;
//       const Carbon_Emitted_2024 = company.carbon_emitted_2024;
//       const Carbon_Emitted_2023 = company.carbon_emitted_2023;
//       const Total_Energy_Consumed_2024 = company.energy_consumed_2024;
//       const Total_Energy_Consumed_2023 = company.energy_consumed_2023;
//       const Annual_Revenue_2024 = company.annual_revenue_2024;
//       const Annual_Revenue_2023 = company.annual_revenue_2023;
//       const Capex_Wind_2024 = company.capex_wind_2024;
//       const Capex_Solar_2024 = company.capex_solar_2024;
//       const Capex_Other_2024 = company.capex_other_re_2024;
//       const Total_Renewable_2024 = company.re_power_prod_2024;
//       const Total_Renewable_2023 = company.re_power_prod_2023;
//       const Total_Power_2024 = company.power_consumed_2024;
//       const Investment_GH2_2024 = company.gh2_investment_2024;
//       const GH2_Production_2024 = company.gh2_production_2024;
//       const Tree_Plantation_2024 = company.tree_plantation_2024;
//       const Capex_CCS_2024 = company.ccs_capex_2024;
//       const Carbon_Captured_2024 = company.carbon_captured_2024;


//       const writes = [
//         [rowMapping.organisationname, organisationname],
//         [rowMapping.Net_Zero_Target, Net_Zero_Target],
//         [rowMapping.Carbon_Emitted_2024, Carbon_Emitted_2024],
//         [rowMapping.Carbon_Emitted_2023, Carbon_Emitted_2023],
//         [rowMapping.Total_Energy_Consumed_2024, Total_Energy_Consumed_2024],
//         [rowMapping.Total_Energy_Consumed_2023, Total_Energy_Consumed_2023],
//         [rowMapping.Annual_Revenue_2024, Annual_Revenue_2024],
//         [rowMapping.Annual_Revenue_2023, Annual_Revenue_2023],
//         [rowMapping.Capex_Wind_2024, Capex_Wind_2024],
//         [rowMapping.Capex_Solar_2024, Capex_Solar_2024],
//         [rowMapping.Capex_Other_2024, Capex_Other_2024],
//         [rowMapping.Total_Renewable_2024, Total_Renewable_2024],
//         [rowMapping.Total_Renewable_2023, Total_Renewable_2023],
//         [rowMapping.Total_Power_2024, Total_Power_2024],
//         [rowMapping.Investment_GH2_2024, Investment_GH2_2024],
//         [rowMapping.GH2_Production_2024, GH2_Production_2024],
//         [rowMapping.Tree_Plantation_2024, Tree_Plantation_2024],
//         [rowMapping.Capex_CCS_2024, Capex_CCS_2024],
//         [rowMapping.Carbon_Captured_2024, Carbon_Captured_2024],

//       ];

      
//       writes.forEach(([rowNum, value]) => {
//         if (rowNum == null) return; // skip if mapping missing
//         const cellRef = `${col}${rowNum}`;
//         const pre = sheet[cellRef] ? sheet[cellRef].v : undefined;
//         console.log(`pre ${cellRef} =`, pre);

//         let writeVal = value;
//         if (writeVal === undefined || writeVal === null) {
//           writeVal = "";
//         }

//         try {
//           XLSX.utils.sheet_add_aoa(sheet, [[writeVal]], { origin: cellRef });
//           const newCell = sheet[cellRef];
//           if (newCell) {
//             if (typeof writeVal === "number") newCell.t = "n";
//             else if (typeof writeVal === "boolean") newCell.t = "b";
//             else newCell.t = "s";
//           }
//         } catch (e) {
//           sheet[cellRef] = { t: typeof writeVal === "number" ? "n" : "s", v: writeVal };
//         }

//         const post = sheet[cellRef] ? sheet[cellRef].v : undefined;
//         console.log(`post ${cellRef} =`, post);

//         if (colIndex > maxCol) maxCol = colIndex;
//         if (rowNum > maxRow) maxRow = rowNum;
//       });
//     });

//     // update sheet range so Excel shows new cells
//     expandSheetRange(sheet, minCol, minRow, Math.max(maxCol, minCol), Math.max(maxRow, minRow));
//     console.log("Updated sheet !ref:", sheet["!ref"]);

//     // write workbook and download
//     const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([wbout], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//     saveAs(blob, `Modified_${TEMPLATE_FILENAME}`);
//     console.log("Excel exported successfully.");
//   };

//   if (loading) return <div>Loading API data...</div>;
//   if (error) return <div style={{ color: "red" }}>{error}</div>;

//   return (
   
//     <></>
//   );
// };

// export default ExcelGNZ;


import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import apiClient from "../../api/axiosClient";
import { useNavigate } from "react-router-dom";

const TEMPLATE_FILENAME = "Goal Net Zero Company of the Year Award_2025.xlsx";

const rowMapping = {
  organisationname: 5,
  Net_Zero_Target:10,
  Carbon_Emitted_2024: 15,
  Carbon_Emitted_2023: 16,
  Total_Energy_Consumed_2024:26,
  Total_Energy_Consumed_2023:27,
  Annual_Revenue_2024:29,
  Annual_Revenue_2023:30,
  Capex_Wind_2024:34,
  Capex_Solar_2024:35,
  Capex_Other_2024:36,
  Total_Renewable_2024:38,
  Total_Renewable_2023:39,
  Total_Power_2024:44,
  Investment_GH2_2024:47,
  GH2_Production_2024:49,
  Tree_Plantation_2024:51,
  Capex_CCS_2024:54,
  Carbon_Captured_2024:56,
};

/** Helpers for Excel columns / range */
const colLetter = (colIndex) => {
  let letters = "";
  while (colIndex >= 0) {
    letters = String.fromCharCode((colIndex % 26) + 65) + letters;
    colIndex = Math.floor(colIndex / 26) - 1;
  }
  return letters;
};

const colIndexFromLetter = (col) => {
  let index = 0;
  for (let i = 0; i < col.length; i++) {
    index = index * 26 + (col.charCodeAt(i) - 65 + 1);
  }
  return index - 1;
};

const expandSheetRange = (sheet, minCol, minRow, maxCol, maxRow) => {
  const start = `${colLetter(minCol)}${minRow}`;
  const end = `${colLetter(maxCol)}${maxRow}`;
  sheet["!ref"] = `${start}:${end}`;
};

const ExcelGNZ = () => {
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [exported, setExported] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const resp = await apiClient.get("/vw-goalnetzero-submitted/");
        const results = (resp.data && (resp.data.results ?? resp.data)) || [];
        console.log("API results length:", results.length);
        setApiData(results);
      } catch (err) {
        console.error("API fetch error:", err);
        setError("Failed to fetch API data. See console.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (!loading && !error && apiData && apiData.length > 0 && !exported) {
      (async () => {
        try {
          await performExport(apiData);
          setExported(true);
        } catch (err) {
          console.error("Auto-export failed:", err);
        }
      })();
    }
  }, [loading, error, apiData, exported]);

  // Helper that tries many field names
  const getVal = (obj, ...keys) => {
    for (const k of keys) {
      if (!k) continue;
      const val = obj[k];
      if (val !== undefined && val !== null) return val;
    }
    return undefined;
  };

  // resolve merges: if (r,c) lies inside a merged range, return top-left of that merge
  const resolveMergeCell = (sheet, r, c) => {
    const merges = sheet["!merges"] || [];
    for (const m of merges) {
      if (r >= m.s.r && r <= m.e.r && c >= m.s.c && c <= m.e.c) {
        return { r: m.s.r, c: m.s.c };
      }
    }
    return { r, c };
  };

  const performExport = async (dataToWrite) => {
    if (!dataToWrite || dataToWrite.length === 0) {
      throw new Error("No API data to export.");
    }

    const url = encodeURI(`${process.env.PUBLIC_URL || ""}/templates/${TEMPLATE_FILENAME}`);
    console.log("Fetching template:", url);
    const resp = await fetch(url);
    if (!resp.ok) throw new Error(`Template not found (status ${resp.status})`);

    const contentType = resp.headers.get("content-type") || "";
    if (contentType.includes("text/html")) {
      const txt = await resp.text();
      console.error("Template fetch returned HTML (first 300 chars):", txt.slice(0, 300));
      throw new Error("Template returned HTML. Check file path/name.");
    }

    const arrayBuffer = await resp.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];
    console.log("Using sheet:", sheetName, "initial !ref:", sheet["!ref"]);

    // existing bounds
    const existingRef = sheet["!ref"] || "A1:A1";
    const [startRef, endRef] = existingRef.split(":");
    const startColLetter = (startRef || "A1").replace(/[0-9]/g, "");
    const startRow = parseInt((startRef || "A1").replace(/[A-Z]/gi, ""), 10) || 1;
    const endColLetter = (endRef || startRef || "A1").replace(/[0-9]/g, "");
    const endRow = parseInt((endRef || startRef || "A1").replace(/[A-Z]/gi, ""), 10) || 1;

    let minCol = colIndexFromLetter(startColLetter || "A");
    let minRow = startRow;
    let maxCol = colIndexFromLetter(endColLetter || "A");
    let maxRow = endRow;

    // Choose start column (zero-based). Change START_COL if you want to begin at G (6) or somewhere else.
    const START_COL = 9; // 6 => column G. Adjust if your template expects a different starting column.

    dataToWrite.forEach((company, idx) => {
      const colIndex = START_COL + idx; // zero-based
      const col = colLetter(colIndex);
      console.log(`\n--- Writing company #${idx + 1} into column ${col} (zero-based ${colIndex}) ---`);
      console.log("Company raw keys:", Object.keys(company).slice(0,50)); // quick peek

      // attempt multiple key names for each field to be resilient to API changes
      const organisationname = getVal(company, "organisation_name", "organisationname", "org_name", "organisation");
      const Net_Zero_Target = getVal(company, "net_zero_target_2024", "net_zero_target", "net_zero_target_2023");
      const Carbon_Emitted_2024 = getVal(company, "carbon_emitted_2024", "carbon_emitted");
      const Carbon_Emitted_2023 = getVal(company, "carbon_emitted_2023");
      const Total_Energy_Consumed_2024 = getVal(company, "energy_consumed_2024", "total_energy_consumed_2024");
      const Total_Energy_Consumed_2023 = getVal(company, "energy_consumed_2023");
      const Annual_Revenue_2024 = getVal(company, "annual_revenue_2024", "revenue_2024");
      const Annual_Revenue_2023 = getVal(company, "annual_revenue_2023");
      const Capex_Wind_2024 = getVal(company, "capex_wind_2024");
      const Capex_Solar_2024 = getVal(company, "capex_solar_2024");
      const Capex_Other_2024 = getVal(company, "capex_other_re_2024", "capex_other_2024");
      const Total_Renewable_2024 = getVal(company, "re_power_prod_2024", "total_renewable_2024");
      const Total_Renewable_2023 = getVal(company, "re_power_prod_2023");
      const Total_Power_2024 = getVal(company, "power_consumed_2024");
      const Investment_GH2_2024 = getVal(company, "gh2_investment_2024");
      const GH2_Production_2024 = getVal(company, "gh2_production_2024");
      const Tree_Plantation_2024 = getVal(company, "tree_plantation_2024");
      const Capex_CCS_2024 = getVal(company, "ccs_capex_2024");
      const Carbon_Captured_2024 = getVal(company, "carbon_captured_2024");

      const writes = [
        [rowMapping.organisationname, organisationname, "organisationname"],
        [rowMapping.Net_Zero_Target, Net_Zero_Target, "Net_Zero_Target"],
        [rowMapping.Carbon_Emitted_2024, Carbon_Emitted_2024, "Carbon_Emitted_2024"],
        [rowMapping.Carbon_Emitted_2023, Carbon_Emitted_2023, "Carbon_Emitted_2023"],
        [rowMapping.Total_Energy_Consumed_2024, Total_Energy_Consumed_2024, "Total_Energy_Consumed_2024"],
        [rowMapping.Total_Energy_Consumed_2023, Total_Energy_Consumed_2023, "Total_Energy_Consumed_2023"],
        [rowMapping.Annual_Revenue_2024, Annual_Revenue_2024, "Annual_Revenue_2024"],
        [rowMapping.Annual_Revenue_2023, Annual_Revenue_2023, "Annual_Revenue_2023"],
        [rowMapping.Capex_Wind_2024, Capex_Wind_2024, "Capex_Wind_2024"],
        [rowMapping.Capex_Solar_2024, Capex_Solar_2024, "Capex_Solar_2024"],
        [rowMapping.Capex_Other_2024, Capex_Other_2024, "Capex_Other_2024"],
        [rowMapping.Total_Renewable_2024, Total_Renewable_2024, "Total_Renewable_2024"],
        [rowMapping.Total_Renewable_2023, Total_Renewable_2023, "Total_Renewable_2023"],
        [rowMapping.Total_Power_2024, Total_Power_2024, "Total_Power_2024"],
        [rowMapping.Investment_GH2_2024, Investment_GH2_2024, "Investment_GH2_2024"],
        [rowMapping.GH2_Production_2024, GH2_Production_2024, "GH2_Production_2024"],
        [rowMapping.Tree_Plantation_2024, Tree_Plantation_2024, "Tree_Plantation_2024"],
        [rowMapping.Capex_CCS_2024, Capex_CCS_2024, "Capex_CCS_2024"],
        [rowMapping.Carbon_Captured_2024, Carbon_Captured_2024, "Carbon_Captured_2024"],
      ];

      writes.forEach(([rowNum, value, fieldName]) => {
        if (rowNum == null) return; // missing mapping
        const rZero = rowNum - 1;
        const cZero = colIndex;

        // resolve merges (if writing inside a merged cell, write to master)
        const { r: rResolved, c: cResolved } = resolveMergeCell(sheet, rZero, cZero);

        // If value is undefined/null -> set to empty string but log it
        let writeVal = value;
        if (writeVal === undefined || writeVal === null || writeVal === "") {
          console.warn(`Company #${idx + 1} field "${fieldName}" missing -> writing empty string to ${colLetter(cResolved)}${rResolved + 1}`);
          writeVal = "";
        }

        // Try to coerce numeric-looking strings to numbers
        if (typeof writeVal === "string") {
          const trimmed = writeVal.trim();
          if (trimmed !== "" && /^-?\d+(\.\d+)?$/.test(trimmed)) {
            writeVal = Number(trimmed);
          }
        }

        // Use sheet_add_aoa with { origin: { r, c } } for robust placement
        try {
          XLSX.utils.sheet_add_aoa(sheet, [[writeVal]], { origin: { r: rResolved, c: cResolved } });
          const cellAddress = `${colLetter(cResolved)}${rResolved + 1}`;
          const newCell = sheet[cellAddress];
          if (newCell) {
            if (typeof writeVal === "number") newCell.t = "n";
            else if (typeof writeVal === "boolean") newCell.t = "b";
            else newCell.t = "s";
          }
          console.log(`WROTE ${fieldName} -> ${colLetter(cResolved)}${rResolved + 1} =`, writeVal);
        } catch (e) {
          console.error("Write failed for", fieldName, "at", rResolved, cResolved, e);
          // fallback: write raw cell object
          const fallbackCellRef = `${colLetter(cZero)}${rowNum}`;
          sheet[fallbackCellRef] = { t: typeof writeVal === "number" ? "n" : "s", v: writeVal };
        }

        if (cZero > maxCol) maxCol = cZero;
        if (rowNum > maxRow) maxRow = rowNum;
      });
    });

    // update sheet range so Excel shows new cells
    expandSheetRange(sheet, minCol, minRow, Math.max(maxCol, minCol), Math.max(maxRow, minRow));
    console.log("Updated sheet !ref:", sheet["!ref"]);

    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, `Modified_${TEMPLATE_FILENAME}`);
    console.log("Excel exported successfully.");
  };

  if (loading) return <div>Loading API data...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;
  return (
    <>
      {navigate("/Thankyou")}
    </>
  );
};

export default ExcelGNZ;
